module.exports = __webpack_public_path__ + "static/media/logo5.adf61db3.png";